import { Card, Table } from 'react-bootstrap'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Loading from '../../../templates/UI/Loading/Loading'

const PhoneCheck = ({ data, dataLoaded }) => {
    return (
        <Card className="mb-4">
            <Card.Header>
                <div>Phone Check</div>
            </Card.Header>
            <table className='table table-borderless table-striped'>
                <tbody>
                    <tr>
                        <td width="20%" className="font-weight-bold">Mobile Phone: </td>
                        <td>{data.info.mobile_phone}</td>
                    </tr>
                    <tr>
                        <td className="font-weight-bold">Alternate Phone: </td>
                        <td>{data.info.phone}</td>
                    </tr>
                </tbody>

            </table>
            <div className="m-2 font-weight-bold">Other affiliates (up to 10) with this same phone number:</div>
            <Table striped bordered>
                <thead>
                    <tr>
                        <th>Affiliate ID</th>
                        <th>Affiliate</th>
                        <th>Status</th>
                        <th>Contact</th>
                    </tr>
                </thead>
                {dataLoaded ? (
                    <>
                        {data.success && data.info.matchingPhones.length > 0 ? (
                            <tbody>
                                {data.info.matchingPhones.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.affiliate_id}</td>
                                            <td>
                                                <Affiliate aid={item.affiliate_id} name={item.name} status={item.aff_status_value} priority={item.aff_priority_value} />
                                            </td>
                                            <td>{item.aff_status}</td>
                                            <td>{item.contact}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan="4">No data found</td>
                                </tr>
                            </tbody>
                        )}
                    </>
                ) : (
                    <Loading />
                )}
            </Table>
        </Card>
    )
}

export default PhoneCheck
